import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Options } from '../primitives/dotMenu/DotMenu';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import PickListWithApiSearch, { PICKLIST_TYPES } from '../shared/Fields/PickListWithAPISearch';
import { AppConstants } from '../../constants/AppConstants';
import { Config } from './Configuration';
import BackspaceIcon from '@heroicons/react/outline/BackspaceIcon';
import { cloneDeep } from 'lodash';
import {
  getChildOrganizations,
  getOrganization,
  getOrganizations
} from '../../http/organization-services';
import { getLoggedInOrg } from '../../util/admin-utils';
import { HTTP_STATUS } from '../../http/constants/http.status';
import { getOrganizationSettings } from '../../http/configuration-services';
import { setSelectedConfigOrg } from '../../app/mobileConfigurationReducer';

const SelectOrganization = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const userProfileInfo: any = useAppSelector((state) => state.userManagement.userProfileInfo);
  const selectedOrg = useAppSelector((state) => state.mobileConfiguration.selectedConfigOrg);

  const [orgData, setOrgData] = useState<any>([]);

  const [config, setConfig] = useState<Config>({
    loading: true,
    hasMore: true,
    page: AppConstants.DEFAULT_PAGE
  });

  let searchString: string = '';

  const loadOrgData = async (name: string = '', initialCall = false) => {
    let trimmedSearchString = name.trim();
    let currentList = cloneDeep(orgData);
    let pageVal = AppConstants.DEFAULT_PAGE;

    const { page } = config;
    if (!initialCall) {
      if (searchString === name) {
        setConfig({ ...config, page: page + 1, loading: true });
        searchString = name;
        pageVal = page + 1;
      } else {
        setConfig({
          ...config,
          page: AppConstants.DEFAULT_PAGE,

          loading: true
        });
        searchString = name;
        pageVal = AppConstants.DEFAULT_PAGE;
      }
    }

    try {
      let response;
      if (trimmedSearchString.length) {
        response = await getOrganizations(
          trimmedSearchString,
          pageVal,
          AppConstants.DEFAULT_PAGE_SIZE,
          `name,asc`
        );
      } else {
        const { organizationId } = getLoggedInOrg(userProfileInfo);
        response = await getOrganizations(
          trimmedSearchString,
          pageVal,
          AppConstants.DEFAULT_PAGE_SIZE,
          'name,asc'
        );
      }
      const { status, data: organizationResp } = response;
      if (status == HTTP_STATUS.HTTP_OK) {
        const { data, paging } = organizationResp;
        if (pageVal === AppConstants.DEFAULT_PAGE) {
          setOrgData(data);
        } else {
          setOrgData([...currentList, ...data]);
        }
        setConfig({
          ...config,
          loading: false,
          hasMore: paging?.next ? true : false
        });
      }
    } catch (e) {
      setConfig({ ...config, loading: false }); //TODO: Show Failure Toast
    }
  };

  useEffect(() => {
    loadOrgData('', true);
    return () => {
      setConfig({ ...config, page: AppConstants.DEFAULT_PAGE });
    };
  }, []);

  const fetchMoreDataFun = (name: string = '') => {
    loadOrgData(name);
  };

  return (
    <div className="z-10 flex w-full flex-row">
      <PickListWithApiSearch
        fieldKey="id"
        fieldValues={['name']}
        selectedItems={selectedOrg}
        onSelectedChange={(data: any) => {
          dispatch(setSelectedConfigOrg(data));
        }}
        label={''}
        items={orgData}
        disabled={false}
        readOnly={false}
        type={PICKLIST_TYPES.SINGLE}
        searchable={true}
        fetchMoreData={fetchMoreDataFun}
        hasMore={config.hasMore}
        searchPlaceholder={t('T_SEARCH_ORG_NAME')}
        defaultPlaceholder={t('T_OVERRIDE_ALL_SETTINGS')}
        isLoading={config.loading}
        resetData={() => {
          dispatch(setSelectedConfigOrg([]));
        }}
      />
      {/* {selectedOrg.length ? (
        <BackspaceIcon
          className="ml-2 h-7 w-7 self-center"
          onClick={() => {
            setSelectedOrg([]);
          }}
        ></BackspaceIcon>
      ) : (
        ''
      )} */}
    </div>
  );
};

export default SelectOrganization;
